import { Icon, ListItemButton, ListItemText, Theme, Tooltip } from '@mui/material';
import { ReactNode } from 'react';
import { makeStyles } from '@mui/styles';

interface NavigationButtonProps {
    icon?: ReactNode;
    text: string | ReactNode;
    inset?: boolean;
    onClick?: () => void;
    drawerCollapsed?: boolean;
    isActive?: boolean;
    suffix?: ReactNode;
}

const useStyles = makeStyles((theme: Theme) => ({
    iconBase: {
        fontSize: theme.sidebar.iconSize,
        color: theme.sidebar.palette.activeLink,
        height: 24,
        verticalAlign: 'middle',

        '& svg': {
            fontSize: theme.sidebar.iconSize,
        },
    },
    fontIcon: {
        marginTop: -4,
        lineHeight: 'unset',
    },
    textBase: {
        fontSize: theme.sidebar.linkItemSize,
        color: theme.sidebar.palette.activeLink,
    },
    inactive: {
        color: theme.sidebar.palette.text,
    },
    gutters: {
        paddingLeft: (theme.sidebar.widthCollapsed - theme.sidebar.iconSize) / 2,
    },
    hover: {
        '&:hover': {
            backgroundColor: '#2E353D',
        },
    },
}));

export const NavigationButton = (props: NavigationButtonProps) => {
    const classes = useStyles();

    const textStyle = `${classes.textBase} ${!props.isActive && classes.inactive}`;
    const title = props.drawerCollapsed && props.text ? props.text : '';

    let renderIcon = null;
    if (props.icon) {
        const iconStyle = `${classes.iconBase} ${!props.isActive && classes.inactive}`;
        if (typeof props.icon === 'string') {
            renderIcon = <Icon classes={{ root: iconStyle }} className={`${props.icon} ${classes.fontIcon}`} />;
        } else {
            renderIcon = <span className={iconStyle}>{props.icon}</span>;
        }
    }

    return (
        <Tooltip title={title} placement="right">
            <ListItemButton
                onClick={props.onClick}
                classes={{
                    root: classes.hover,
                    gutters: classes.gutters,
                }}
                disableGutters={false}
                sx={{
                    '&& .MuiTouchRipple-child': {
                        color: theme => theme.sidebar.palette.text,
                    },
                }}
            >
                {renderIcon}
                <ListItemText primary={props.text} inset={props.inset} classes={{ primary: textStyle }} />
                {props.suffix}
            </ListItemButton>
        </Tooltip>
    );
};
